var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaused(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.10612 5.40873V10.7377C7.10612 10.9315 6.94908 11.0885 6.75537 11.0885H5.62935C5.43584 11.0885 5.27881 10.9315 5.27881 10.7377V5.40873C5.27881 5.21522 5.43584 5.05798 5.62935 5.05798H6.75537C6.94908 5.05798 7.10612 5.21522 7.10612 5.40873Z",
    fill: "#F0C427"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7692 5.40873V10.7377C10.7692 10.9315 10.6122 11.0885 10.4185 11.0885H9.29244C9.09893 11.0885 8.94189 10.9315 8.94189 10.7377V5.40873C8.94189 5.21522 9.09893 5.05798 9.29244 5.05798H10.4185C10.6122 5.05798 10.7692 5.21522 10.7692 5.40873Z",
    fill: "#F0C427"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99939 1.83623C4.66399 1.83623 1.95044 4.6083 1.95044 8.01565C1.95044 11.423 4.66399 14.1951 7.99939 14.1951C11.3348 14.1951 14.0483 11.423 14.0483 8.01565C14.0483 4.6083 11.3348 1.83623 7.99939 1.83623ZM8.00004 15.9431C3.72133 15.9431 0.23999 12.3869 0.23999 8.01567C0.23999 3.64443 3.72133 0.0882568 8.00004 0.0882568C12.279 0.0882568 15.7601 3.64443 15.7601 8.01567C15.7601 12.3869 12.279 15.9431 8.00004 15.9431Z",
    fill: "#F0C427"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaused);
export default __webpack_public_path__ + "static/media/paused.889f080090bb3c39dadd9a1ea8d5f6e6.svg";
export { ForwardRef as ReactComponent };